/**
 * What the business's plan unlocks — `business.features` on `/business/me`.
 *
 * A feature the plan leaves out is refused by the API with
 * `403 plan_feature_unavailable`; the portal hides it (and offers the upgrade)
 * instead of showing screens that would only fill with errors. A cached
 * profile from before the field existed counts as "on", the server deciding.
 */
export const hasFeature = (user, feature) => user?.business?.features?.[feature] !== false;
